const initializePearlCardDecks = () => {
  const decks = document.querySelectorAll('[data-card-deck]');

  decks.forEach((deck) => {
    const cards = [...deck.querySelectorAll('[data-card-card]')];
    if (!cards.length) return;
    const isResourceDeck = deck.dataset.cardDeck === 'resources';

    const setFront = (card) => {
      cards.forEach((item) => item.classList.toggle('is-front', item === card));
    };

    cards.forEach((card, index) => {
      card.style.setProperty('--card-index', index);
      if (isResourceDeck) {
        card.addEventListener('pointerenter', () => deck.classList.add('is-card-hover'));
        card.addEventListener('pointerleave', () => deck.classList.remove('is-card-hover'));
      }

      if (isResourceDeck) {
        card.addEventListener('pointerenter', () => {
          cards.forEach((item) => item.classList.toggle('is-hovered', item === card));
        });
        card.addEventListener('pointerleave', () => card.classList.remove('is-hovered'));
      }
    });

    setFront(cards[0]);

    deck.addEventListener('pointerenter', () => deck.classList.add('is-active'));
    deck.addEventListener('pointerleave', () => {
      deck.classList.remove('is-active', 'is-card-hover');
      cards.forEach((card) => {
        card.classList.remove('is-hovered');
        card.style.removeProperty('--magnetic-x');
        card.style.removeProperty('--magnetic-y');
      });
    });

    if (isResourceDeck) {
      deck.addEventListener('pointermove', (event) => {
        const bounds = deck.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;

        cards.forEach((card, index) => {
          const direction = index < cards.length / 2 ? -1 : 1;
          card.style.setProperty('--magnetic-x', `${x * direction * 12}px`);
          card.style.setProperty('--magnetic-y', `${y * -8}px`);
        });
      });
    }

    deck.addEventListener('click', (event) => {
      const raiseControl = event.target.closest('[data-card-raise]');
      if (!raiseControl || !deck.contains(raiseControl)) return;

      event.preventDefault();
      event.stopPropagation();
      const card = raiseControl.closest('[data-card-card]');
      if (card) setFront(card);
    });

    deck.addEventListener('keydown', (event) => {
      const raiseControl = event.target.closest('[data-card-raise]');
      if (!raiseControl || !deck.contains(raiseControl)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      const card = raiseControl.closest('[data-card-card]');
      if (card) setFront(card);
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePearlCardDecks, { once: true });
} else {
  initializePearlCardDecks();
}
